module.exports = __webpack_public_path__ + "img/thumb_30.c5aef97e.jpg";